import { ENDPOINT_ROOT } from '@/common/constants';
import axiosAuth from '@/common/interceptors/axios.AuthInterceptor';

const getCarts = ({
  queryKey: [endpoint, editherm, user, hasProducts, sources],
}) => {
  let params = {
    user,
    sources,
  };

  if (hasProducts) {
    params = {
      ...params,
      has_products: hasProducts,
    };
  }

  if (editherm) {
    params = {
      ...params,
      editherm: 1,
    };
  }

  return axiosAuth
    .get(`${ENDPOINT_ROOT}/${endpoint}`, { params })
    .then((res) => res.data);
};

export default getCarts;
